module.exports = __webpack_public_path__ + "img/2484dfdd03181484f13a89461e6ccb57.83737936.png";